import React from 'react';

import { Artifact } from '../../../../types/service';

import './index.scss';

interface ArtifactCardProps {
  artifact: Artifact
}

const ArtifactCard: React.FunctionComponent<ArtifactCardProps> = ({artifact}) => {
  return (
    <React.Fragment>
      <p className="artifact-name">{artifact.name}</p>
      <p className="artifact-version">{artifact.version_string}</p>
    </React.Fragment>
  )
}

export default ArtifactCard;